/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { RmCalculationType } from './RmCalculationType';
import {
    RmCalculationTypeFromJSON,
    RmCalculationTypeFromJSONTyped,
    RmCalculationTypeToJSON,
    RmCalculationTypeToJSONTyped,
} from './RmCalculationType';
import type { CalculationType } from './CalculationType';
import {
    CalculationTypeFromJSON,
    CalculationTypeFromJSONTyped,
    CalculationTypeToJSON,
    CalculationTypeToJSONTyped,
} from './CalculationType';
import type { RrpCalculationType } from './RrpCalculationType';
import {
    RrpCalculationTypeFromJSON,
    RrpCalculationTypeFromJSONTyped,
    RrpCalculationTypeToJSON,
    RrpCalculationTypeToJSONTyped,
} from './RrpCalculationType';

/**
 * 
 * @export
 * @interface GetCalculationTypesResponse
 */
export interface GetCalculationTypesResponse {
    /**
     * 
     * @type {Array<CalculationType>}
     * @memberof GetCalculationTypesResponse
     */
    calculationTypes: Array<CalculationType>;
    /**
     * 
     * @type {Array<RmCalculationType>}
     * @memberof GetCalculationTypesResponse
     */
    rmCalculationTypes: Array<RmCalculationType>;
    /**
     * 
     * @type {Array<RrpCalculationType>}
     * @memberof GetCalculationTypesResponse
     */
    rrpCalculationTypes: Array<RrpCalculationType>;
}

/**
 * Check if a given object implements the GetCalculationTypesResponse interface.
 */
export function instanceOfGetCalculationTypesResponse(value: object): value is GetCalculationTypesResponse {
    if (!('calculationTypes' in value) || value['calculationTypes'] === undefined) return false;
    if (!('rmCalculationTypes' in value) || value['rmCalculationTypes'] === undefined) return false;
    if (!('rrpCalculationTypes' in value) || value['rrpCalculationTypes'] === undefined) return false;
    return true;
}

export function GetCalculationTypesResponseFromJSON(json: any): GetCalculationTypesResponse {
    return GetCalculationTypesResponseFromJSONTyped(json, false);
}

export function GetCalculationTypesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCalculationTypesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'calculationTypes': ((json['calculationTypes'] as Array<any>).map(CalculationTypeFromJSON)),
        'rmCalculationTypes': ((json['rmCalculationTypes'] as Array<any>).map(RmCalculationTypeFromJSON)),
        'rrpCalculationTypes': ((json['rrpCalculationTypes'] as Array<any>).map(RrpCalculationTypeFromJSON)),
    };
}

export function GetCalculationTypesResponseToJSON(json: any): GetCalculationTypesResponse {
    return GetCalculationTypesResponseToJSONTyped(json, false);
}

export function GetCalculationTypesResponseToJSONTyped(value?: GetCalculationTypesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'calculationTypes': ((value['calculationTypes'] as Array<any>).map(CalculationTypeToJSON)),
        'rmCalculationTypes': ((value['rmCalculationTypes'] as Array<any>).map(RmCalculationTypeToJSON)),
        'rrpCalculationTypes': ((value['rrpCalculationTypes'] as Array<any>).map(RrpCalculationTypeToJSON)),
    };
}

